import { Node, ReactNodeViewRenderer } from '@tiptap/react'
import Component from './component'

export const Spacer = Node.create({
	name: 'spacer',
	group: 'block',
	content: '',
	selectable: false,
	atom: true,
	addAttributes() {
		return {
			width: {
				default: '2%',
			},
		}
	},
	parseHTML() {
		return [{ tag: this.name }]
	},
	renderHTML({ node }) {
		const width = node.attrs.width
		return [
			this.name,
			{
				'data-type': 'spacer',
				width: width,
				style: `width: ${width}; font-size: 0; line-height: 0;`,
			},
			'&nbsp;',
		]
	},
	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})
